angular.module('app').component('googleToolbar', {
    templateUrl: 'js/components/google-toolbar/index.html',
    controller: GoogleToolbarController,
    controllerAs: '$gt',
    bindings: {
        api: '<',
    },
});

GoogleToolbarController.$inject = [
    '$scope',
    '$cookies',
    'toaster',
    '$translate',
    '$ngConfirm',
    'Microservice',
    '$q',
    '$http',
    'ZoneShapeDrawing',
    'ZoneShapeGroupDrawing',
    'ComponentTranslations',
];

function GoogleToolbarController(
    $scope,
    $cookies,
    toaster,
    $translate,
    $ngConfirm,
    Microservice,
    $q,
    $http,
    ZoneShapeDrawing,
    ZoneShapeGroupDrawing,
    ComponentTranslations
) {
    var $ctrl = this;

    $ctrl.collapsed = true;
    $ctrl.tab = 'settings';

    $ctrl.isTabOn = function(tab) {
        return $ctrl.tab === tab;
    };

    $ctrl.changeTab = function(tab) {
        if ($ctrl.tab === tab) {
            $ctrl.toggle();
        } else {
            $ctrl.collapsed = false;
        }
        $ctrl.tab = tab;
    };

    $ctrl.toggle = function() {
        $ctrl.collapsed = !$ctrl.collapsed;
    };

    $ctrl.labels = {
        multiselect: ComponentTranslations.multiselect(),
    };

    /*
     * Cookies settings section
     */

    var cookieExpirationDate = new Date();
    cookieExpirationDate.setDate(cookieExpirationDate.getDate() + 365);

    $ctrl.settings = {
        object: null,
        options: {
            isAutomaticRefresh: false,
            groupObjectsOn: true,
            plateNamesOn: true,
            objectsDrawingAuto: true,
            trafficOnMap: false,
        },
        isManualRefreshTurned: false,
        toggleAutomaticRefresh: function(v) {
            $ctrl.settings.options.isAutomaticRefresh = v;
            $cookies.put('isAutomaticRefresh', v ? 1 : -1, {
                expires: cookieExpirationDate,
            });

            if (typeof $ctrl.api.on.load === 'function') {
                $ctrl.api.on.load();
            }
        },
    };

    $ctrl.zones = {
        map: null,
        form: {
            shape: false,
            overlay: null,
            edit: {},
        },
        list: {
            zones: false,
            groups: false,
        },
        overlays: [],
        sd: null,
        sgd: null,
        openModal: function() {
            var $isolated = $scope.$new(true);

            $isolated.data = {
                shape: $ctrl.zones.sd.shape,
                groups: $ctrl.api.groups,
            };

            $isolated.form = {
                active: 1,
                margin: 10,
            };

            var edit = $ctrl.zones.form.edit;
            if (edit.id) {
                $isolated.form = {
                    active: edit.active,
                    name: edit.name,
                    description: edit.description,
                    margin: edit.margin,
                    zoneGroupId: edit.zoneGroupId,
                    groupId: edit.groupId,
                };
            }

            $ctrl.zones
                .getApiData('groups', 'zone-groups')
                .then(function(data) {
                    $isolated.data.zoneGroups = data;

                    $ngConfirm({
                        title: $translate.instant('components.gt.modals.zone.header'),
                        contentUrl: 'js/components/google-toolbar/modals/zone.html',
                        animation: 'rotate',
                        theme: 'supervan',
                        columnClass: 'medium',
                        icon: 'pe-7s-vector pe-lg pe-va',
                        scope: $isolated,
                        buttons: {
                            yes: {
                                text: $translate.instant('general.confirm.save.ok'),
                                btnClass: 'btn-success',
                                action: function(scope) {
                                    var form = scope.form;
                                    var payload = $ctrl.zones.getPayload(form);

                                    var promise = $ctrl.zones.save(payload);
                                    $scope.$apply();

                                    return promise
                                        .then(function() {
                                            return $ctrl.zones.getApiData('zones', 'zones', true).catch(() => {});
                                        })
                                        .then(function() {
                                            $ctrl.zones.sgd && $ctrl.zones.sgd.reload('zones', false);
                                        });
                                },
                            },
                            no: {
                                text: $translate.instant('general.confirm.save.cancel'),
                                btnClass: 'btn-dark',
                            },
                        },
                    });
                })
                .catch(() => {});
        },
        getApiData: function(list, action, force) {
            var deferred = $q.defer();

            if ($ctrl.zones.list[list] === false || force) {
                Microservice.interceptor('zone', 'get', '/' + action)
                    .then(function(response) {
                        var result = response.data ? response.data : [];

                        $ctrl.zones.list[list] = result;
                        if ($ctrl.zones.sgd) {
                            $ctrl.zones.sgd[list].list = result;
                        }

                        deferred.resolve(result);
                    })
                    .catch(deferred.reject);
            } else {
                deferred.resolve($ctrl.zones.list[list]);
            }

            return deferred.promise;
        },
        openZonesModal: function() {
            var $isolated = $scope.$new(true);
            var modalInstance = undefined;

            $isolated.actions = {
                mapper: function(zone) {
                    var searched = ($ctrl.zones.list.groups || []).filter(function(zoneGroup) {
                        return zoneGroup.id === zone;
                    });
                    return searched.length ? searched[0].name : '-';
                },
                edit: function(zone) {
                    $ctrl.zones.sgd.resetShapes();
                    modalInstance && modalInstance.close();
                    $ctrl.zones.setupZoneEditMode(zone);
                },
                delete: function(zone) {
                    return Microservice.interceptor('zone', 'delete', '/zones/' + zone.id)
                        .then(function() {
                            return $ctrl.zones.getApiData('zones', 'zones', true);
                        })
                        .then(function() {
                            modalInstance && modalInstance.close();
                            $ctrl.zones.openZonesModal();

                            $ctrl.zones.sgd && $ctrl.zones.sgd.reload('zones', false);
                        })
                        .catch(() => {});
                },
            };
            $isolated.form = {};
            $isolated.data = {
                groups: $ctrl.api.groups,
            };

            $ctrl.zones.getApiData('groups', 'zone-groups').catch(() => {});

            $ctrl.zones
                .getApiData('zones', 'zones')
                .then(function(data) {
                    $isolated.data.zones = data;
                    if (!data.length) {
                        return;
                    }

                    modalInstance = $ngConfirm({
                        title: $translate.instant('components.gt.zone-list.header'),
                        contentUrl: 'js/components/google-toolbar/modals/list.html',
                        animation: 'rotate',
                        theme: 'supervan',
                        columnClass: 'large',
                        icon: 'pe-7s-keypad pe-lg pe-va',
                        scope: $isolated,
                        buttons: {
                            no: {
                                text: $translate.instant('general.confirm.save.cancel'),
                                btnClass: 'btn-dark',
                            },
                        },
                    });
                })
                .catch(() => {});
        },
        openZoneGroupsModal: function() {
            var $isolated = $scope.$new(true);
            var modalInstance = undefined;

            $isolated.data = {
                editMode: false,
                groups: $ctrl.api.groups,
                zoneGroups: $ctrl.zones.list.groups,
            };

            $isolated.actions = {
                goEditMode: function(group) {
                    $isolated.data.editMode = true;
                    $isolated.form = group;
                },
                getPayload: function(form) {
                    var payload = angular.copy(form);

                    !$isolated.data.editMode && delete payload.id;
                    delete payload.createdAt;
                    delete payload.updateAt;

                    return payload;
                },
                save: function(edit, id, payload) {
                    var method = edit ? 'put' : 'post';
                    var action = edit ? '/zone-groups/' + id : '/zone-groups';

                    return Microservice.interceptor('zone', method, action, payload)
                        .then(function() {
                            return $ctrl.zones.getApiData('groups', 'zone-groups', true);
                        })
                        .then(function() {
                            modalInstance && modalInstance.close();
                            $ctrl.zones.sgd && $ctrl.zones.sgd.reload('groups', false);

                            return true;
                        })
                        .catch(() => {});
                },
                delete: function(zoneGroup) {
                    return Microservice.interceptor('zone', 'delete', '/zone-groups/' + zoneGroup.id)
                        .then(function() {
                            return $ctrl.zones.getApiData('groups', 'zone-groups', true);
                        })
                        .then(function() {
                            modalInstance && modalInstance.close();
                            $ctrl.zones.sgd && $ctrl.zones.sgd.reload('groups', false);

                            return true;
                        })
                        .catch(() => {});
                },
            };
            $isolated.form = {};

            $ctrl.zones
                .getApiData('groups', 'zone-groups')
                .then(function(data) {
                    $isolated.data.zoneGroups = data;

                    modalInstance = $ngConfirm({
                        title: $translate.instant('components.gt.zone-groups.header'),
                        contentUrl: 'js/components/google-toolbar/modals/groups.html',
                        animation: 'rotate',
                        theme: 'supervan',
                        columnClass: 'large',
                        icon: 'pe-7s-keypad pe-lg pe-va',
                        scope: $isolated,
                        buttons: {
                            yes: {
                                text: $translate.instant('general.confirm.save.ok'),
                                btnClass: 'btn-success',
                                action: function(scope) {
                                    var form = scope.form;
                                    var payload = scope.actions.getPayload(form);

                                    if (!payload.name) {
                                        toaster.error(
                                            $translate.instant('general.toastr.error.header'),
                                            $translate.instant('components.gt.zone-groups.toastr.error.empty')
                                        );
                                        return false;
                                    }

                                    var promise = scope.actions.save(scope.data.editMode, scope.form.id, payload);
                                    $scope.$apply();

                                    return promise
                                        .then(function() {
                                            return $ctrl.zones.getApiData('groups', 'zone-groups', true);
                                        })
                                        .then(function() {
                                            modalInstance && modalInstance.close();
                                            $ctrl.zones.sgd && $ctrl.zones.sgd.reload('groups', false);
                                        });
                                },
                            },
                            no: {
                                text: $translate.instant('general.confirm.save.cancel'),
                                btnClass: 'btn-dark',
                            },
                        },
                    });
                })
                .catch(() => {});
        },
        openImportModal: function() {
            var $isolated = $scope.$new(true);

            $isolated.results = false;
            $isolated.loading = false;
            $isolated.all = false;

            $isolated.import = function() {
                $isolated.results = false;
                $isolated.loading = true;

                $http
                    .get('/api/zone/import')
                    .then(
                        function(response) {
                            var results = response.data.data;

                            $isolated.results = results;
                            $isolated.loading = false;

                            if (results.exported.zones.created > 0) {
                                $ctrl.zones.getApiData('zones', 'zones', true);
                            }
                            if (results.exported.groups.created > 0) {
                                $ctrl.zones.getApiData('groups', 'zone-groups', true);
                            }

                            var summary = results.exported.zones.created + results.exported.zones.existing;
                            if (results.exported.zones.all <= summary) {
                                $isolated.all = true;
                            }
                        },
                        function() {
                            $isolated.loading = false;
                            toaster.error(
                                $translate.instant('general.toastr.error.header'),
                                $translate.instant('components.gt.zones.toastr.error.import')
                            );
                        }
                    )
                    .catch(() => {});
            };

            $ngConfirm({
                title: $translate.instant('components.gt.zones.importing'),
                contentUrl: 'js/components/google-toolbar/modals/import.html',
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'large',
                icon: 'fas fa-file-import',
                scope: $isolated,
                buttons: {
                    no: {
                        text: $translate.instant('general.confirm.close'),
                        btnClass: 'btn-danger',
                    },
                },
            });
        },
        setupZoneEditMode: function(zone) {
            var shape = $ctrl.zones.sd.shapes[zone.type];
            var data = $ctrl.zones.sd.loadShape(shape, zone.parameters);

            $ctrl.zones.form.edit = zone;
            $ctrl.zones.map.fitBounds(data.bounds);
        },
        getPayload: function(form) {
            var getParameters = function(overlay, type) {
                switch (type) {
                    case 'CIRCLE':
                        var center = overlay.getCenter();
                        var radius = overlay.getRadius();

                        return {
                            center: {
                                lat: center.lat(),
                                lng: center.lng(),
                            },
                            radius: radius / 1000,
                        };
                    case 'RECTANGLE':
                        var bounds = overlay.getBounds();

                        var NE = bounds.getNorthEast();
                        var SW = bounds.getSouthWest();

                        return {
                            topRight: {
                                lat: NE.lat(),
                                lng: NE.lng(),
                            },
                            bottomLeft: {
                                lat: SW.lat(),
                                lng: SW.lng(),
                            },
                        };
                    case 'POLYLINE':
                    case 'POLYGON':
                        var path = overlay.getPath().getArray();

                        return {
                            points: path.map(function(o) {
                                return {
                                    lat: o.lat(),
                                    lng: o.lng(),
                                };
                            }),
                        };
                }
                return false;
            };

            var payload = {
                type: $ctrl.zones.sd.shapes.indexOf($ctrl.zones.sd.shape),
                parameters: getParameters($ctrl.zones.sd.overlay, $ctrl.zones.sd.shape),
            };

            return angular.extend(form, payload);
        },
        save: function(payload) {
            var method = 'post';
            var action = '/zones';

            if ($ctrl.zones.form.edit.id) {
                method = 'put';
                action = '/zones/' + $ctrl.zones.form.edit.id;
            }

            $ctrl.zones.form.edit = {};
            $ctrl.zones.sd.setDrawingState('reset');

            return Microservice.interceptor('zone', method, action, payload).then(
                function() {
                    toaster.success(
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant('components.gt.zones.toastr.success.save')
                    );
                },
                function() {
                    toaster.error(
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('components.gt.zones.toastr.error.save')
                    );
                }
            );
        },
    };

    var api = {
        zoneIsTurnOn: function() {
            return $ctrl.api.modes.indexOf('zones') >= 0;
        },
        setIsManualRefreshTurned: function(v) {
            $ctrl.settings.isManualRefreshTurned = v;
        },
        getIsManualRefreshTurned: function() {
            return $ctrl.settings.isManualRefreshTurned;
        },
        getIsAutomaticRefresh: function() {
            return $ctrl.settings.options.isAutomaticRefresh;
        },
        getOption: function(k) {
            return $ctrl.settings.options[k];
        },
        setOption: function(k, v) {
            if ($ctrl.settings.options[k] === v) {
                return false;
            }

            $ctrl.settings.options[k] = v;
            $cookies.put(k, v ? 1 : -1, {
                expires: cookieExpirationDate,
            });

            if (typeof $ctrl.api.on[k] === 'function') {
                $ctrl.api.on[k](v);
            }
        },
        onGoogleMapLoad: function(map) {
            fireGoogleMapLoad(map);
        },
        setSelected: function(o) {
            $ctrl.settings.object = o;
        },
    };

    var initCookies = function() {
        var keys = Object.keys($ctrl.settings.options);

        for (var i = 0; i < keys.length; i++) {
            var value = $cookies.get(keys[i]);
            if (value) {
                $ctrl.settings.options[keys[i]] = value > 0;
            }
        }
    };

    var fireGoogleMapLoad = function(map) {
        $ctrl.zones.map = map;

        if ($ctrl.api.zoneIsTurnOn()) {
            initSearchBox();

            $ctrl.zones.sd = new ZoneShapeDrawing(
                map,
                {
                    onChangeDrawingState: function(state) {
                        if (state === 'reset') {
                            $ctrl.zones.form.edit = {};
                        }
                    },
                },
                $scope
            );

            $ctrl.zones
                .getApiData('zones', 'zones', false)
                .then(() => {
                    $ctrl.zones
                        .getApiData('groups', 'zone-groups', false)
                        .then(() => {
                            $ctrl.zones.sgd = new ZoneShapeGroupDrawing(
                                $ctrl.zones.sd,
                                $ctrl.zones.list.zones,
                                $ctrl.zones.list.groups
                            );
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        }

        getAccess();
    };

    /*
     * Google search box
     */

    var onSearchBoxChanged = function(places) {
        if (!places || places.length === 0) {
            toaster.pop(
                'error',
                $translate.instant('general.toastr.error.header'),
                $translate.instant('plannings.autocomplete.unreachable')
            );
            $scope.$apply();

            return;
        }

        if (typeof $ctrl.api.on.zonePlaceChanged === 'function') {
            var place = places[0];
            if (place) {
                var location = place.geometry.location;
                $ctrl.api.on.zonePlaceChanged(location.lat(), location.lng());
            }
        }
    };

    var initSearchBox = function() {
        var searchbox = document.getElementById('searchbox-input');
        $ctrl.googleSearchBox = new google.maps.places.SearchBox(searchbox, {});

        $ctrl.googleSearchBox.addListener('places_changed', function() {
            var places = $ctrl.googleSearchBox.getPlaces();
            onSearchBoxChanged(places);
        });
    };

    /*
     * Component initialization
     */

    var getAccess = function() {
        var endpoint = '/api/applicationSetting/client/get';

        $http.get(endpoint).then(function(response) {
            if (response.data.data.isShowTrafficOnMaps) {
                $ctrl.api.access.traffic = true;
                $ctrl.api.on.trafficOnMap();
            }
        });
    };

    $ctrl.$onInit = function() {
        api.ready = true;
        $ctrl.api = angular.extend($ctrl.api, api);

        if (typeof $ctrl.api.onInit === 'function') {
            $ctrl.api.onInit();
        }

        initCookies();
    };

    $ctrl.$postLink = function() {};
    $ctrl.$onChanges = function() {};
}
